import { HTTP_GET, HTTP_POST, WebApiRequest, WebApiReduxRequest } from "tools/webservice";
import { BEGIN_UPDATE_CASE_ISSUES, REQ_POST_CASE_ISSUES, RES_POST_CASE_ISSUES, ERR_POST_CASE_ISSUES } from "typeConstants/index";
export const getCaseIssueTypes = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/issues/${controlNumber}/case-issue-types`,
  successCallback,
  mountedRef,
});
export const getCaseIssues = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/issues/${controlNumber}/case-issues`,
  successCallback,
  mountedRef,
});
export const updateCaseIssues = (payload, successCallback, mountedRef) => WebApiReduxRequest(
  REQ_POST_CASE_ISSUES, RES_POST_CASE_ISSUES, ERR_POST_CASE_ISSUES,
  HTTP_POST,
  `/issues/case-issues`,
  payload, 
  successCallback,
  mountedRef,
);
export const beginUpdateCaseIssues = () => {
  return {
    type: BEGIN_UPDATE_CASE_ISSUES,
    payload: { value: true },
  };
};

export const getAppraiserCaseIssueTypes = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/issues/${controlNumber}/appraiser-case-issue-types`,
  successCallback,
  mountedRef,
});
export const getAppraiserCaseIssues = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/issues/${controlNumber}/appraiser-case-issues`,
  successCallback,
  mountedRef,
});
export const updateAppraiserCaseIssues = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/issues/appraiser-case-issues`,
  payload, successCallback,
  mountedRef,
});

